var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9168 53.0417V39.0833H39.0834V53.0417C39.0834 54.5771 40.3397 55.8333 41.8751 55.8333H50.2501C51.7855 55.8333 53.0418 54.5771 53.0418 53.0417V33.5H57.7876C59.0718 33.5 59.6859 31.9088 58.7088 31.0713L35.3705 10.05C34.3097 9.10084 32.6905 9.10084 31.6297 10.05L8.29134 31.0713C7.34217 31.9088 7.92842 33.5 9.21259 33.5H13.9584V53.0417C13.9584 54.5771 15.2147 55.8333 16.7501 55.8333H25.1251C26.6605 55.8333 27.9168 54.5771 27.9168 53.0417Z",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d0a1fbaa5269053f91c8cd505822cf0f.svg";
export { ForwardRef as ReactComponent };